import { Component, Inject, OnInit, Optional } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ContentdataService } from '../services/contentdata.service';

@Component({
  selector: 'app-edit-faq',
  templateUrl: './edit-faq.component.html',
  styleUrls: ['./edit-faq.component.css']
})
export class EditFaqComponent implements OnInit {

  faqDetails;

  constructor(private contentDataService:ContentdataService,private toast:ToastrService,private spinner:NgxSpinnerService,public dialogRef:MatDialogRef<EditFaqComponent> ,@Optional() @Inject(MAT_DIALOG_DATA) public data: any)
  {
    this.faqDetails = data.faqData;
    console.log(this.faqDetails);
  }

  ngOnInit(): void {
  }

  editFaq(form:NgForm)
  {
    // console.log(form.value);
    let faqData = {
      id:this.faqDetails._id,
      title:form.value.title,
      description:form.value.description
    };
    this.contentDataService.updateFaq(faqData).subscribe(res=>{
      if(res["status"])
      {
        this.spinner.hide();
        this.toast.success(res["description"]);      
        this.closeModel();
      }
      else{        
        this.spinner.hide();
        this.toast.error(res["description"]);
      }
      },err=>{      
        console.log(err);
        this.spinner.hide();
        this.toast.error(err.error["description"]);
    });
  }

  closeModel()
  {
    this.dialogRef.close();
    this.contentDataService.filter("scale");
  }

}
